const cardItems = [
  {
    title: '画质对比：标清到4K蓝光的进化',
    desc: '从360P到4K，同一画面的不同分辨率对比，让你直观感受桃子影院蓝光画质的震撼效果。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20comparison%20of%20low%20to%20high%20resolution%20visual%20quality%2C%20pixel%20evolution%20concept%2C%20dark%20background%20with%20warm%20golden%20accents%2C%20modern%20minimal%20design&width=640&height=400&seq=cards-01-quality&orientation=landscape',
    tag: '技术解析',
    tagClass: 'bg-primary-500/20 text-primary-400',
  },
  {
    title: '暑期档必看：10部高口碑新片推荐',
    desc: '这个夏天最值得期待的十部影片，从国产佳片到海外大作，桃子影院为你一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20collage%20concept%20with%20warm%20sunset%20tones%2C%20abstract%20film%20elements%2C%20dark%20elegant%20background%2C%20golden%20light%20streaks&width=640&height=400&seq=cards-02-summer&orientation=landscape',
    tag: '观影指南',
    tagClass: 'bg-accent-500/20 text-accent-400',
  },
  {
    title: '从入门到精通：影视字幕设置全攻略',
    desc: '如何选择最佳字幕？双语字幕、特效字幕如何开启？桃子影院字幕设置详细教程。',
    img: 'https://readdy.ai/api/search-image?query=Minimalist%20typography%20and%20subtitle%20design%20concept%2C%20dark%20background%20with%20soft%20warm%20lighting%2C%20elegant%20text%20elements%2C%20cinematic%20atmosphere&width=640&height=400&seq=cards-03-subtitle&orientation=landscape',
    tag: '使用教程',
    tagClass: 'bg-secondary-500/20 text-secondary-400',
  },
  {
    title: '周末影院：三刷依然震撼的经典影片',
    desc: '有些电影值得反复观看，每次都有新的感悟。桃子影院为你整理那些历久弥新的传世佳作。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20cinema%20atmosphere%20with%20warm%20amber%20lighting%2C%20classic%20film%20projector%20elements%2C%20rich%20textured%20dark%20background%2C%20elegant%20old%20Hollywood%20vibe&width=640&height=400&seq=cards-04-weekend&orientation=landscape',
    tag: '片单推荐',
    tagClass: 'bg-primary-500/20 text-primary-400',
  },
  {
    title: '音效进化：从单声道到杜比全景声',
    desc: '好的音效让观影体验提升一个档次。了解不同音频格式的区别，选择最适合你设备的播放设置。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20sound%20wave%20and%20audio%20visualization%20concept%2C%20dark%20background%20with%20warm%20golden%20and%20peach%20accents%2C%20minimal%20design%2C%20cinematic%20mood&width=640&height=400&seq=cards-05-audio&orientation=landscape',
    tag: '影音科普',
    tagClass: 'bg-accent-500/20 text-accent-400',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full mb-4">
            影视资讯
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            观影指南与影视资讯
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            精选观影指南、技术科普和影视资讯，提升你的观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cardItems.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-200/60 rounded-xl overflow-hidden border border-background-300/20 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              <div className="h-[180px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4">
                <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium mb-2 ${item.tagClass}`}>
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          {cardItems.slice(3).map((item, idx) => (
            <div
              key={idx + 3}
              className="group bg-background-200/60 rounded-xl overflow-hidden border border-background-300/20 hover:border-primary-500/20 transition-all duration-300 cursor-pointer sm:col-span-2 lg:col-span-2"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-[220px] h-[160px] sm:h-auto overflow-hidden flex-shrink-0">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="p-4 flex-1">
                  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium mb-2 ${item.tagClass}`}>
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}